exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.background-yellow[data-v-e4705ea6] {\n    background: rgba(245, 184, 33, 0.8);\n}\n.menu-icon[data-v-e4705ea6] {\n    width: 24px;\n    height: 24px;\n}\n", ""]);

// exports
